export default function ({ store, from }) {
  if (process.client && from) {
    return store.dispatch('tracking/comingFrom', {
      name: from.name,
      path: from.path,
      query: from.query,
    })
  }
}
